import { RefreshCw } from "lucide-react-native";
import { useState } from "react";
import { Box } from "../../../../ui/box";
import {
  Button,
  ButtonIcon,
  ButtonSpinner,
  ButtonText,
} from "../../../../ui/button";
import { Text } from "../../../../ui/text";
import { VStack } from "../../../../ui/vstack";
import { AGENT_ACTIONS } from "../../actions";
import { useAgentForm } from "./AgentFormContext";
import { unpersistedConcepts } from "./formFlow";

/**
 * "Generar otros" — under the offered set, while the session offers `regenerate_concepts`
 * (until one of them is chosen).
 *
 * Replaces the whole set; the old cards stay above, marked as based on an earlier
 * brief. Hidden while a job runs (the backend would refuse it) and once a concept is
 * chosen (from then on, changes go through the chat).
 */
const ConceptSetActions = () => {
  const { flow, live, busy, can, regenerateConcepts } = useAgentForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const hasOffer =
    flow.hasCurrentConcepts ||
    unpersistedConcepts(live.concepts.items, flow.persistedConceptIds).length >
      0;
  if (!hasOffer || !can(AGENT_ACTIONS.regenerateConcepts) || busy) return null;

  const regenerate = async () => {
    setError(null);
    setLoading(true);
    const result = await regenerateConcepts();
    setLoading(false);
    if (!result.ok) setError(result.errors[0]?.message ?? null);
  };

  return (
    <Box className="mb-3 ml-[30px]">
      <VStack space="xs" className="items-start">
        <Button
          action="muted"
          variant="outline"
          size="md"
          className="min-h-11"
          isDisabled={loading}
          onPress={() => void regenerate()}
        >
          {loading ? <ButtonSpinner /> : <ButtonIcon as={RefreshCw} />}
          <ButtonText>Generar otros</ButtonText>
        </Button>
        {error ? (
          <Text role="alert" className="text-sm text-error-600">
            {error}
          </Text>
        ) : null}
      </VStack>
    </Box>
  );
};

export default ConceptSetActions;
